<script>import InputInline from "../InputInline.svelte";
import InputSelect from "./InputSelect.svelte";
import { attrValue } from "../../../../utils/html";
export let props;
export let phoneCodesProps;
export let withCode;
</script>

<div class="md:flex md:space-x-4">
	{#if withCode && phoneCodesProps}
		<div class="md:w-1/3">
			<InputSelect bind:props={phoneCodesProps} />
		</div>
	{/if}
	<div class={attrValue([withCode && phoneCodesProps ? 'md:w-2/3' : 'w-full'])}>
		<InputInline type="tel" pattern="[0-9]+" bind:props />
	</div>
</div>
